import { useEffect, useState } from "react";
import { Plus, Search, X } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { QuickCompanyDialog } from "@/components/sales/QuickCompanyDialog";

export const CompanyPicker = ({ value, onChange, disabled, testId = "company-picker", source = "/crm/companies", allowCreate = false }) => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [searched, setSearched] = useState(false);
  const [creating, setCreating] = useState(false);
  useEffect(() => {
    setSearched(false);
    if (value || q.trim().length < 2) { setItems([]); return undefined; }
    const t = setTimeout(() => api.get(source, { params: { q, limit: 8 } }).then((r) => setItems(r.data.items)).catch(() => setItems([])).finally(() => setSearched(true)), 250);
    return () => clearTimeout(t);
  }, [q, value, source]);

  return (
    <div className="space-y-1.5">
      <Label className="text-xs">Cliente</Label>
      {value ? (
        <div className="flex h-9 items-center justify-between rounded-control border border-line bg-slate-50 px-3 text-sm" data-testid={`${testId}-selected`}>
          <span className="truncate font-medium text-ink">{value.name}</span>
          {!disabled && <button type="button" onClick={() => onChange(null)} className="text-slate-400 hover:text-ink" data-testid={`${testId}-clear`}><X className="h-4 w-4" /></button>}
        </div>
      ) : (
        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
          <Input className="pl-9" placeholder="Cerca cliente (min. 2 caratteri)" value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testId}-input`} />
          {(items.length > 0 || (allowCreate && searched)) && (
            <ul className="absolute z-50 mt-1 max-h-56 w-full overflow-auto rounded-control border border-line bg-white py-1 shadow-lg">
              {items.map((c) => (
                <li key={c.id}><button type="button" onClick={() => { onChange({ id: c.id, name: c.name }); setQ(""); }}
                  className="w-full px-3 py-2 text-left text-sm hover:bg-slate-50" data-testid={`${testId}-option-${c.id}`}>
                  <span className="font-medium text-ink">{c.name}</span>{c.city && <span className="ml-2 text-xs text-slate-500">{c.city}</span>}
                </button></li>
              ))}
              {allowCreate && searched && (
                <li className={items.length ? "border-t border-line" : ""}><button type="button" onClick={() => setCreating(true)}
                  className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm font-medium text-brand-700 hover:bg-slate-50" data-testid={`${testId}-create`}>
                  <Plus className="h-4 w-4" />{items.length ? "Non c'è? Crea nuovo cliente" : `Crea nuovo cliente "${q.trim()}"`}
                </button></li>
              )}
            </ul>
          )}
        </div>
      )}
      {allowCreate && <QuickCompanyDialog open={creating} onOpenChange={setCreating} initialName={q.trim()} onCreated={(c) => { onChange(c); setQ(""); }} />}
    </div>
  );
};
